/* eslint-disable react/prop-types */
import { ChevronDownIcon, ChevronUpIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Flex,
  HStack,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import EditConditionsForm from "../EditConditionsForm/EditConditionForm";

const ConditionsAccordion = ({ initialData, onConditionsChange }) => {
  const [conditions, setConditions] = useState(new Map());
  const [expandedItems, setExpandedItems] = useState(new Map());

  useEffect(() => {
    const conditionsMap = new Map();
    const expandedMap = new Map();
    initialData.forEach((data, idx) => {
      conditionsMap.set(idx, data);
      expandedMap.set(idx, false); // collapsed by default
    });
    setConditions(conditionsMap);
    setExpandedItems(expandedMap);
  }, [initialData]);

  const handleUpdate = (updatedCondition, key) => {
    const newMap = new Map(conditions);
    newMap.set(key, updatedCondition);
    setConditions(newMap);
    onConditionsChange(Array.from(newMap.values()));
  };

  const handleDelete = (key) => {
    const newMap = new Map(conditions);
    newMap.delete(key);

    const newExpanded = new Map(expandedItems);
    newExpanded.delete(key);

    setConditions(newMap);
    setExpandedItems(newExpanded);

    onConditionsChange(Array.from(newMap.values()));
  };

  const toggleExpand = (key) => {
    setExpandedItems((prev) => new Map(prev).set(key, !prev.get(key)));
  };

  return (
    <Box>
      <Text fontWeight="bold" mb={3}>
        CONDITIONS:
      </Text>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
        {Array.from(conditions.entries()).map(([key, condition]) => {
          const isExpanded = expandedItems.get(key);

          return (
            <Box
              key={key}
              display="flex"
              flexDirection="column"
              borderWidth="1px"
              borderRadius="md"
              shadow="sm"
              overflow="hidden"
              _hover={{ shadow: "md" }}
            >
              {/* Header */}
              <Flex
                bg="gray.50"
                p={3}
                align="center"
                justify="space-between"
                cursor="pointer"
                onClick={() => toggleExpand(key)}
              >
                <Box>
                  <Text fontWeight="bold">{condition.Field}</Text>
                  <Text fontSize="sm" color="gray.500">
                    {condition.Operator} —{" "}
                    {Array.isArray(condition.Value)
                      ? condition.Value.join(", ")
                      : condition.Value}
                  </Text>
                </Box>

                <HStack spacing={2}>
                  <DeleteIcon
                    cursor="pointer"
                    color="red"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(key);
                    }}
                  />
                  {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </HStack>
              </Flex>

              {/* Expandable Panel */}
              <Collapse in={isExpanded} animateOpacity>
                <Box p={4} bg="white">
                  <EditConditionsForm
                    data={condition}
                    onSubmit={(updatedData) => handleUpdate(updatedData, key)}
                  />
                </Box>
              </Collapse>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  );
};

export default ConditionsAccordion;
